// Components
import ReconciliationUnitsEditableTable from "./ReconciliationUnitsEditableTable";

// Types
import { GridColDef } from "@mui/x-data-grid-pro";
import { TExtraTableProps } from "@/DataPages/types/inventory/commons";

type UnitsOnMfgTableProps = Readonly<{
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	extraTableProps?: TExtraTableProps;
	hasNextPage: boolean;
}>;

const columns: GridColDef[] = [
	{
		field: "_id",
		headerName: "ID",
	},
	{ field: "status", width: 45, headerName: "" },
	{ field: "type", headerName: "Type", width: 60 },
	{
		field: "vinNumber",
		headerName: "VIN",
		width: 140,
	},
	{
		field: "manuallyReconciled",
		headerName: "",
		editable: true,
	},
	{
		field: "year",
		headerName: "Year",
		type: "number",
		headerAlign: "right",
		align: "right",
		width: 60,
	},
	{
		field: "_empty",
		headerName: "",
		width: 80,
	},
	{
		field: "make",
		headerName: "Make",
		width: 160,
	},
	{
		field: "model",
		headerName: "Model",
		width: 170,
	},
	{
		field: "color",
		headerName: "Color",
		width: 150,
	},
	{
		field: "reason",
		headerName: "Reason",
		width: 140,
		editable: true,
	},
	{
		field: "resolution",
		headerName: "Resolution",
		width: 140,
		editable: true,
	},
	{
		field: "notes",
		headerName: "Notes",
		headerAlign: "right",
		align: "right",
		width: 80,
		editable: true,
	},
];

export default function UnitsOnMfgTable(props: UnitsOnMfgTableProps) {
	const { extraTableProps, locationId, commissionCycleId, payPeriodId, hasNextPage } = props;
	return (
		<ReconciliationUnitsEditableTable
			columns={columns}
			extraTableProps={extraTableProps}
			locationId={locationId}
			commissionCycleId={commissionCycleId}
			payPeriodId={payPeriodId}
			hasNextPage={hasNextPage}
			table="onMfg"
		/>
	);
}
